import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'site-modules/shared/components/link/link';

export function DealerReviewDisclaimer({ isUpdate = false }) {
  return (
    <div
      className={classnames('text-gray-darker medium', { 'mt-1_5': !isUpdate, 'mb-1_5': isUpdate })}
      data-test="legal-copy"
    >
      All reviews and comments submitted to Edmunds are subject to the terms of our{' '}
      <Link to="/about/visitor-agreement.html" target="_blank" rel="noopener noreferrer" className="text-underline">
        Visitor Agreement
      </Link>
      .
    </div>
  );
}

DealerReviewDisclaimer.propTypes = {
  isUpdate: PropTypes.bool,
};
